<template>
  <div class="border-layout" style="width: 1200px">
    <div>
      <div class="p-fluid p-grid">
        <div class="p-field p-col-12 p-md-1 p-input-filled">
          <label for="number">Номер</label>
          <InputText id="number" type="text" v-model="data.number" readonly tabindex="-1" aligh="right"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="date">Дата</label>
          <Calendar id="date" :showIcon="true" v-model="date" :showButtonBar="true"/>
          <small class="p-invalid" v-if="submitted && !data.date">Полето е задължително.</small>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="store">Склад / търговски обект</label>
          <AutoComplete v-model="data.store" :dropdown="true" field="name"
            :suggestions="stores" @complete="searchStore($event)" placeholder="Въведете група"/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="contragent">Клиент</label>
          <AutoComplete v-model="data.contragent" :dropdown="true" field="name"
            :suggestions="contragents" @complete="searchContragent($event)" placeholder="Въведете клиент"
            @item-select="onContragentSelect"
          />
        </div>
        <div class="p-field p-col-12 p-md-1">
          <label for="discount">ТО %</label>
          <InputText v-model="defaultDiscountPerc" readonly/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="payment-method">Начин на плащане</label>
          <Dropdown v-model="data.paymentMethod" :options="paymentMethods"
            optionLabel="title" optionValue="code"
            id="payment-method" placeholder="Въведете начин на плащане"
            />
        </div>
        <!--
        <div class="p-field p-col-12 p-md-3">
          <label>&nbsp;</label>
          <div class="p-field-checkbox">
            <Checkbox id="unofficial" v-model="data.unofficial" :binary="true"/>
            <label for="unofficial">&nbsp;Продажбата е неофициална</label>
          </div>
        </div>
        -->
      </div>
    </div>
    <DataTable :value="data.items"
        dataKey="pos"
        :rowHover="true"
        :scrollable="true"
        scrollHeight="flex"
        @row-select="onItemSelect"
        selectionMode="single"
        ref="table"
        style="height: calc(100vh - 350px)"
        v-model:selection="tbl.selectedItems"
        class="p-datatable-striped p-datatable-sm"
        showGridlines>
      <template #header>
        <div class="table-header">
          <h3 class="p-m-0">Списък на продадените стоки</h3>
          <div class="p-field-checkbox">
            <Checkbox id="priceIncludesVat" v-model="data.priceIncludesVat" :binary="true" :disabled="true"/>
            <label for="priceIncludesVat">&nbsp;Цена с включен ДДС</label>
          </div>
          <div class="p-field-checkbox">
            <label for="priceIncludesVat">Продажба по цени {{wholesailer ? "на едро" : "на дребно"}}</label>
          </div>
          <span class=p-buttonset>
            <Button
                label="Добави"
                icon="pi pi-plus"
                class="p-button-success"
                @click="onItemCreate"
            />
            <Button
                label="Редактирай"
                icon="pi pi-pencil"
                class="p-button-primary"
                @click="onItemEdit"
                :disabled="!tbl.selected"
            />
            <Button
                label="Изтрий"
                icon="pi pi-trash"
                class="p-button-danger"
                @click="onItemDelete"
                :disabled="!tbl.selected"
            />
          </span>
        </div>
      </template>
      <Column field="pos" header="№" bodyClass="right" style="flex: 0 0 3em">
        <template #body="props">
          {{props.index + 1 + '.'}}
        </template>
      </Column>
      <Column field="product" header="Код" style="flex: 0 0 7em">
        <template #body="props">
          {{props.data.product ? props.data.product.number: ''}}
        </template>
      </Column>
      <Column field="product" header="Наименование" style="flex-grow: 4000">
        <template #body="props">
          {{props.data.product ? props.data.product.name : ''}}
        </template>
        <template #footer>
          Общо {{count}} записа
        </template>
      </Column>
      <Column field="quantity" header="К-во" bodyClass="right" style="flex: 0 0 4em">
        <template #body="props">
          {{$utils.value(props.data.quantity)}}
        </template>
      </Column>
      <Column field="data.measure" header="Мярка" style="flex: 0 0 5em" bodyClass="center">
        <template #body="props">
          {{props.data.product ? props.data.product.measure : ''}}
        </template>
      </Column>
      <Column field="price" header="Ед. цена" bodyClass="right" style="flex: 0 0 6em">
        <template #body="props">
          {{getItemPriceFormatted(props.data)}}
        </template>
      </Column>
      <Column field="amount" header="Стойност" style="flex: 0 0 7em" bodyClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.amount)}}
        </template>
        <template #footer>
          {{$utils.currency(amount)}}
        </template>
      </Column>

      <Column field="discountPerc" header="ТО %" style="flex: 0 0 4em" bodyClass="right">
        <template #body="props">
          {{$utils.value(props.data.discountPerc)}}
        </template>
      </Column>

      <Column field="discount" header="ТО" style="flex: 0 0 4em" bodyClass="right">
        <template #body="props">
          {{$utils.currency(props.data.discount)}}
        </template>
      </Column>

      <Column field="netto" header="Нето" style="flex: 0 0 6em" bodyClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.netto)}}
        </template>
        <template #footer>
          {{$utils.currency(netto)}}
        </template>
      </Column>
      <Column field="vatPerc" header="ДДС %" style="flex: 0 0 6em" bodyClass="right" footerClass="right">
        <template #body="props">
          {{$utils.value(props.data.vatPerc)}}
        </template>
      </Column>
      <Column field="vat" header="ДДС" style="flex: 0 0 6em" bodyClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.vat)}}
        </template>
        <template #footer>
          {{$utils.currency(vat)}}
        </template>
      </Column>
      <Column field="total" header="Общо" style="flex: 0 0 6em" bodyClass="right" footerClass="right">
        <template #body="props">
          {{$utils.currency(props.data.total)}}
        </template>
        <template #footer>
          {{$utils.currency(total)}}
        </template>
      </Column>
    </DataTable>
  </div>

  <Chooser ref="contragents" title="Избор на контрагент" @select="onSelectContragent">
    <template #default="{ onSelect }">
      <Contragents @select="onSelect"/>
    </template>
  </Chooser>

  <SaleItem @load="onItemLoad" @save="onItemSave" @calculate="applyProductAndSaleConditionsForItem" v-model:visible="tbl.edit"
    v-model:data="tbl.selected" title="Продадена стока"/>

</template>

<script>
export default {
  data() {
    var model = this.modelValue;
    var document = {contragent: {}, store: {}, items: [], properties: {}};
    if (model) {
      document = model;
      if (!document.contragent) {
        document.contragent = model.contragent;
      }
      if (!document.store) {
        document.store = model.store;
      }
      if (!document.items) {
        document.items = model.items;
      }
      if (!document.propertie) {
        document.properties = model.properties;
      }
    }
    return {
      data: document,
      editing: null,
      stores : [],
      contragents : [],
      paymentTypes : [],
      products : [],
      editingRows: [],
      submitted: false,
      importerVisible: false,
      tbl: {
        selected: null,
        selectedItems: [],
        edit: false,
      },
      priceTypes: [
        {name: "Продажба на едро", value: "wholesale"},
        {name: "Продажба на дребно", value: "retail"}
      ],
      paymentMethods: [
        {code: "cash", title: "В брой"},
        {code: "bank", title: "По сметка"},
        {code: "ppp", title: "Пощенски паричен превод"},
        {code: "card", title: "С карта"},
      ],
    }
  },

  props: {
    modelValue: Object
  },
  mounted() {
    if(this.data) {
      if (this.data.items) {
        var pos = 1;
        for(var item of this.data.items) {
          item.pos = pos++;
        }
      } else {
        this.data.items = [];
      }
      if (!this.data.properties) {
        this.data.properties = {}
      }
    }
  },
  emits: ['update:modelValue'],
  methods: {
    getItemPriceFormatted(item) {
      // if (!this.data.priceIncludesVat && item.vatPerc > 0) {
      //   return this.$utils.currency(item.price / (1 + item.vatPerc / 100));
      // }
      return this.$utils.currency(item.price);
    },
    onContragentSelect() {
      this.data.priceIncludesVat = !this.data.contragent.wholesailer;
      this.applyProductAndSaleConditions();
    },
    forceUpdate(event) {
      this.$emit('input', event.target.value)
    },
    searchStore(event) {
      var ctx = this;
      this.$http.get('/store', {
        params: {
          query: event.query
        }
      }).then(res => ctx.stores = res.data)
    },
    searchPaymentType(event) {
      var ctx = this;
      this.$http.get('/payment-type', {
        params: {
          query: event.query
        }
      }).then(res => ctx.paymentTypes = res.data)
    },
    searchContragent(event) {
      var ctx = this;
      this.$http.get('/contragent', {
        params: {
          query: event.query
        }
      }).then(res => ctx.contragents = res.data)
    },
    onItemLoad(data) {
      data.sale = this.data;
      data.data = {}
      data = data.data;
      if (this.tbl.selected) {
        var value = this.$utils.value;
        data.product  = this.tbl.selected.product;
        data.batch  = this.tbl.selected.batch;
        data.quantity  = value(this.tbl.selected.quantity);
        data.price  = value(this.tbl.selected.price);
        data.discountPerc  = value(this.tbl.selected.discountPerc);
      }
    },
    onItemSave(data) {
      var selected = false;
      if (this.tbl && this.tbl.selected != null && this.tbl.selected && this.tbl.selected.pos) {
        selected = true;
      }
      if(!selected) {
        var pos = 1;
        for (var i of this.data.items) {
          if (pos <= i.pos) {
            pos = i.pos + 1;
          }
        }
        this.tbl.selected = {
          pos: pos,
          product: null
        }
      }
      for(var k in data) {
        this.tbl.selected[k] = data[k];
      }
      this.calculateItem(this.tbl.selected);
      if(!selected) {
        this.data.items.push(this.tbl.selected)
      }
      this.tbl.selectedItems = this.tbl.selected;
      this.calculate()
    },
    onItemSelect(data) {
      this.tbl.selected = data.data;
    },
    onItemEdit() {
      this.tbl.edit = true;
    },
    onItemCreate() {
      this.tbl.selected = {};
      this.applyProductAndSaleConditionsForItem(this.tbl.selected);
      this.tbl.selectedItems = null;
      this.tbl.edit = true;
    },
    onItemDelete() {
      this.data.items = this.data.items.filter(val => val != this.tbl.selected);
      this.tbl.selected = null;
    },
    onSave(event) {
      event.onSuccess();
    },
    onSelectContragent(data) {
      this.data.contragent = data;
    },
    sum(f) {
      var total = 0;
      if(this.data && this.data.items) {
        for(const item of this.data.items) {
          total += this.$utils.value(f(item));
        }
      }
      return total;
    },
    applyProductAndSaleConditionsForItem(item) {
      var product;
      var wholesailer = false;
      if(item.product !== undefined && item.product) {
        product = item.product;
      }
      if(this.data.contragent !== undefined && this.data.contragent) {
        wholesailer = this.data.contragent.wholesailer;
        item.discountPerc = this.data.contragent.discount;
      }
      var value = this.$utils.value;
      if (product !== undefined) {
        var price;
        if(wholesailer) {
          price = value(product.priceWholesale);
        } else {
          price = value(product.priceRetail);
        }
        if (price !== undefined) {
          // ако цената е с включен ДДС
          if (!this.data.priceIncludesVat) {
            if(!wholesailer) {
              // ако цената е на дребно, е с вквючен ДДС. Цените на едро са без ДДС
              price /= (1 + item.vatPerc / 100.0);
            }
          }
          item.price = price;
        }
      }
      this.calculateItem(item);
    },
    applyProductAndSaleConditions() {
      if(this.data && this.data.items) {
        for(var item of this.data.items) {
          this.applyProductAndSaleConditionsForItem(item);
        }
      }
    },
    calculateItem(item) {
      var value = this.$utils.value;
      item.vatPerc = value(this.vatPerc);
      if (this.data.priceIncludesVat) {
        item.amount = value(item.quantity) * item.price;
        item.discount = (value(item.discountPerc) / 100.0) * item.amount;
        item.total = item.amount - item.discount;
        item.netto = item.vat = 0;
        if(item.vatPerc > 0) {
          item.netto = item.total / (1 + item.vatPerc / 100.0);
          item.vat = item.total - item.netto;
        }
      } else {
        item.amount = value(item.quantity) * item.price;
        item.discount = (value(item.discountPerc) / 100.0) * item.amount;
        item.netto = item.amount - item.discount;
        item.total = item.netto * (1 + item.vatPerc / 100.0);
        item.vat = item.total - item.netto;
      }
    },
    calculate() {
      if(this.data && this.data.items) {
        for(var item of this.data.items) {
          this.calculateItem(item);
        }
      }
    }
  },
  computed: {
    netto: function() {
      return this.sum( item => item.netto );
    },
    vat: function() {
      return this.sum( item => item.vat );
    },
    vatPerc: function() {
      return 20;
    },
    wholesailer: function() {
      if(this.data.contragent && this.data.contragent.wholesailer) {
        return true;
      }
      return false;
    },
    defaultDiscountPerc: function() {
      if(this.data.contragent) {
        return this.data.contragent.discount;
      }
      return 0;
    },
    date: {
      get() {
        if (this.data && this.data.date) {
          if ((typeof this.data.date) == 'string') {
            return new Date(this.data.date);
          }
          return this.data.date;
        }
        return null;
      },
      set(date) {
        this.data.date = date;
      },
    },
    issueInvoice: {
      get() {
        if (this.data && this.data.properties) {
          return this.data.properties.issueInvoice;
        }
        return false;
      },
      set(issueInvoice) {
        if(!this.data.properties) {
          this.data.properties = {}
        }
        var change = this.data.properties.issueInvoice != issueInvoice;
        this.data.properties.issueInvoice = issueInvoice;
        if (change) {
          this.calculate();
        }
      },
    },
    total: function() {
      return this.sum( item => item.total );
    },
    amount: function() {
      return this.sum( item => item.amount );
    },
    count: function() {
      if (this.data && this.data.items) {
        return this.data.items.length;
      }
      return 0;
    }
  }
}
</script>

<style>
</style>